<template>
  <div>
    <DxDataGrid
      :columns="columns"
      :data-source="dataSource"
      :show-borders="true"
      :allow-column-resizing="true"
      :search-panel="searchPanel"
      :showRowLines="true"
      :hover-state-enabled="true"
      :remote-operations="true"
      :ref="dataGridRefKey"
      @cell-prepared="onCellPrepared"
      @selection-changed="getSelectedData"
    >
      <DxSelection show-check-boxes-mode="none" mode="multiple" />
      <DxFilterRow :visible="true" />
      <DxGroupPanel :visible="true" />
      <DxGrouping :auto-expand-all="false" />
      <DxPaging :page-size="10" />
      <DxPager
        :visible="true"
        display-mode="full"
        :show-page-size-selector="false"
        :show-info="true"
        :show-navigation-buttons="true"
      />

      <template #rlt-field="{ data: cellData }">
        <RltField :cell-data="cellData"></RltField>
      </template>
      <template #lnk-field="{ data: cellData }">
        <LinkField
          :cell-data="cellData"
          :mRoute="routeDef"
          :rPrifix="slug"
        ></LinkField>
      </template>
    </DxDataGrid>

    <!-- yha issue ho rha hai br br network call ho rha hai  -->
    <UserRoleManagement
      v-if="
        this.routeDef == 'user-tenant-access-requests' ||
        'tenant-admin-panels.susbscriptions'
      "
      :routeDef="this.routeDef"
      :slug="slug"
      :columnDef="this.columns"
      :parentRoute="this.routeDef"
      ref="user-role-ref"
    >
    </UserRoleManagement>
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPopup,
  DxLookup,
  DxForm,
  DxHeaderFilter,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxPager,
  DxPaging,
  DxSelection,
} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { DxItem } from "devextreme-vue/form";
import UserRoleManagement from "@include/forms/UserRoleManagement.vue";
import { DxTextArea } from "devextreme-vue/text-area";
import RltField from "@/components/ListRelateField.vue";
import LinkField from "@/components/ListLinkField.vue";
import { confirm, alert } from "devextreme/ui/dialog";

function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}
function calculateFilterExpression(
  filterValue,
  selectedFilterOperation,
  target
) {
  let column = this;

  if (filterValue) {
    return [column.dataField, "contains", filterValue];
  }
  return column.defaultCalculateFilterExpression.apply(this, arguments);
}
let mRoute;
let mslug;
function setRoute(context) {
  mRoute = context.routeDef;
  mslug = context.slug;
}
const store = new CustomStore({
  key: "id",
  load: function (loadOptions) {
    var parameters = {};

    if (loadOptions.sort) {
      parameters.order_column = loadOptions.sort[0].selector;
      if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
    }
    parameters.group = JSON.stringify(loadOptions.group);
    parameters.filter = JSON.stringify(loadOptions.filter);
    parameters.skip = loadOptions.skip;
    parameters.take = loadOptions.take;
    parameters.page = (parameters.skip + parameters.take) / parameters.take;
    var config = {
      params: parameters,
    };

    //let listurl = "/" + mRoute + "/list";

    let listurl = route(mRoute + ".list", mslug);
    //let listurl = "/builder/module/list";

    //let listurl = mRoute+"/list";
    // having issue with route()  after slug implementation
    let createurl = "/" + mRoute + "/create";

    return axios
      .get(listurl, config)
      .then((response) => {
        return {
          data: response.data.results.data,
          totalCount: response.data.results.total,
        };
      })
      .catch(() => {
        throw "Data Loading Error";
      });
  },
});

// this instance
var ins = Object();
const dataGridRefKey = "my-data-grid";
export default {
  props: {
    routeDef: String,
    headersDef: Array,
    slug: String,
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxPopup,
    DxLookup,
    DxForm,
    DxItem,
    DxHeaderFilter,
    DxTextArea,
    DxFilterRow,
    DxGrouping,
    DxGroupPanel,
    DxScrolling,
    DxPager,
    DxPaging,
    UserRoleManagement,
    RltField,
    LinkField,
    DxSelection,
    confirm,
    alert,
  },
  methods: {
    actinButtons(cellElement, cellInfo) {
      cellElement.append(
        "<a href='./" +
          this.routeDef +
          "/" +
          cellInfo.data.id +
          "/edit' class='action-btn-link'><i class='fas fa-pencil-alt'></i></a>&nbsp;&nbsp;"
      );
      cellElement.append(
        "<a href='./" +
          this.routeDef +
          "/" +
          cellInfo.data.id +
          "' class='action-btn-link'><i class='far fa-eye'></i></i></a>"
      );
    },
    setColumnDefs() {
      if (this.routeDef == "user-tenant-access-requests") {
        var columnDefs1 = [
          {
            type: "buttons",
            buttons: [
              {
                icon: "todo",
                onClick: function (e) {
                  // this.user_id = e.row.data.user_id;
                  //this.request_type = e.row.data.type;
                  console.log("LINK BUTTON CLICK", e.row.data);
                  if (e.row.data.status == "approved") {
                    alert("Already Approved", "Important!");
                  } else {
                    ins.showUserRoleManagement(e);
                  }
                },
              },
              {
                icon: "remove",
                onClick: function (e) {
                  console.log("Request Rejected");
                },
              },
            ],
          },
        ];
      } else if (this.routeDef == "tenant-admin-panels.subscriptions") {
        var columnDefs1 = [
          {
            type: "buttons",
            buttons: [
              {
                icon: "link",
                onClick: function (e) {
                  // this.user_id = e.row.data.user_id;
                  //this.request_type = e.row.data.type;
                  //alert("hello saurabh");

                 // console.log("LINK BUTTON CLICK", e.row.data);
                 // console.log("LINK BUTTON CLICK relatedUsers", e.row.data.relatedUsers);
            
                  if (e.row.data.isExpired == "Yes") {
                    alert("Your license has been Expired!", "Important!");
                  } else {
                    if (e.row.data.available_licenses > 0) {
                      ins.showUserRoleManagement(e);
                    } else {
                      alert(
                        "You don't have any available  licenses!",
                        "Important!"
                      );
                    }
                  }
                },
              },
            ],
          },
        ];
      } else {
        var columnDefs1 = [];
      }

      //view icon
      var iconDefs = [
        {
          type: "buttons",
          width: 30,
          buttons: [
            {
              icon: "fa fa-eye fa-lg",
              onClick: function (e) {
                // this.user_id = e.row.data.user_id;
                //this.request_type = e.row.data.type;
                ins.goToShow(e);
              },
            },
          ],
        },
      ];

      let result = this.headersDef;

      // console.log("HEADER",this.headersDef);
      let reformattedArray = result.map((obj) => {
        let rObj = {};
        const keys = Object.keys(obj);
        keys.forEach((k, v) => {
          rObj[k] = obj[k];
          if (obj.editorType == "string") {
            rObj["calculateFilterExpression"] = calculateFilterExpression;
          }
        });

        return rObj;
      });

      columnDefs1 = reformattedArray.concat(columnDefs1);
      columnDefs1 = iconDefs.concat(columnDefs1);
      return columnDefs1;
    },

    onCellPrepared(e) {
      /* if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        elem.style.setProperty("color", "blue");
      } */
    },
    onCellHoverChanged(e) {
      /* if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        if (e.eventType === "mouseover") {
          e.cellElement.style.color = "blue";
        } else {
          e.cellElement.style.color = "";
        }

        elem.style.setProperty("color", "green");
      } */
    },
    showUserRoleManagement(e) {
      let ab = "user-role-ref";

      this.$refs[ab].showRolePopUp();
      this.$refs[ab].setData(e);
    },
    goToShow(e) {
      // console.log("ICON CLICK",e.row.data.id);
      this.$inertia.get(
        route(this.routeDef + ".show", [this.slug, e.row.data.id])
      );

      // alert(e.row.data.id);
    },
    getSelectedData() {
      // console.log("SELECTED DATA",this.dataGrid.getSelectedRowsData());
      this.$emit("item_selected", this.dataGrid.getSelectedRowsData());
    },
  },
  mounted() {
    setRoute(this);
    ins = this;
  },
  data() {
    return {
      dataSource: store,
     
      showBorders: true,
      showRowLines: true,
      remoteOperations: true,
      dataGridRefKey,
      columns: this.setColumnDefs(),
      searchPanel: {
        visible: true,
        width: 240,
        placeholder: "Search...",
      },
    };
  },
  computed: {
    dataGrid: function () {
      return this.$refs[dataGridRefKey].instance;
    },
  },
};
</script>

<style>
</style>